<template>
  <nav class="edit_box" :class="[displayMode, size]">
    <button
      id="edit_btn"
      class="edit_btn"
      @click="editAction('dataEdit')"
      v-if="option.includes('edit')"
    ></button>
    <button
      id="remove_btn"
      class="remove_btn"
      @click="removeAction('normal')"
      v-if="option.includes('remove')"
    ></button>
  </nav>
</template>

<script>
export default {
  name: "editBox",
  props: {
    item: String,
    itemId: Number,
    displayMode: String,
    size: String,
    option: Array,
  },
  data() {
    return {
      activeMode: "normal",
    };
  },
  methods: {
    removeAction() {
      alert("remove " + this.itemId + " from " + this.item);
    },
    editAction() {
      alert("edit " + this.itemId + " from " + this.item);
    },
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/editBox/edit_box.css);
</style>
